import React from "react";
import ProductForm from "./components/ProductForm";

const EditProduct = () => {
  return <ProductForm isEdit={true} />;
};

export default EditProduct;
